import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Table from "../../../core/common/dataTable/index";
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl';
import Loading from '../../../core/common/custom-loading/Loading';


type BandType = {
    ID: string,
    band: string,
    status: string
}

const LeadAccProfile = () => {
    const [loading, setLoading] = useState(false)
    const [allItemList, setAllItemList] = useState<any[]>([])
    console.log("allItem List data", allItemList)

    const columns = [
        {
            title: "Sr No.",
            dataIndex: "SrNo",
            render: (text: string, record: any, index: number) => (
                <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
            ),
            sorter: false,
        },
        {
            title: "Name",
            dataIndex: "full_name",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" style={{ width: "max-content" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.full_name || "").localeCompare(b.full_name || ""),
        },
        {
            title: "Email",
            dataIndex: "email",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.email || "").localeCompare(b.email || ""),
        },
        {
            title: "Contact",
            dataIndex: "phone_number",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.phone_number || "").localeCompare(b.phone_number || ""),
        },
        {
            title: "Gender",
            dataIndex: "gender",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.gender || "").localeCompare(b.gender || ""),
        },
        {
            title: "DOB",
            dataIndex: "dob",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) =>
                new Date(a.dob || "").getTime() - new Date(b.dob || "").getTime(),
        },
        // {
        //     title: "Country",
        //     dataIndex: "contact_phone",
        //     sorter: (a: any, b: any) => a.contact_phone.localeCompare(b.contact_phone),
        // },
        {
            title: "Pref Budget(MIN)",
            dataIndex: "pref_budget_min_range",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.pref_budget_min_range - b.pref_budget_min_range,
        },
        {
            title: "Pref Budget(MAX)",
            dataIndex: "pref_budget_max_range",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.pref_budget_max_range - b.pref_budget_max_range,
        },
        {
            title: "Pref Locality",
            dataIndex: "pref_locality",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.pref_locality || "").localeCompare(b.pref_locality || ""),
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string, record: any) => (
                <span className={`badge ${text === '1' ? 'badge-success' : 'badge-danger'} d-inline-flex align-items-center badge-xs`}>
                    <i className="ti ti-point-filled me-1" />
                    {text == "1" ? "Active" : "Inactive"}
                </span>

            ),
            sorter: (a: any, b: any) => a.status - b.status,
            // sorter: (a: any, b: any) => a.status.length - b.status.length,
        },
        // {
        //     title: "Action",
        //     dataIndex: "actions",
        //     render: (_: any, record: any) => (
        //         <div className="action-icon d-inline-flex">
        //             <Link
        //                 to="#"
        //                 className="me-2"
        //             >
        //                 <i className="ti ti-edit" />
        //             </Link>
        //             <Link
        //                 to="#"
        //             >
        //                 <i className="ti ti-trash" />
        //             </Link>
        //         </div>
        //     ),
        // },
    ];


    const fetchData = async () => {
        try {
            setLoading(true);
            const resp = await AXIOSCONFIGMETHOD("get", webServiceUrl.GET_LEAD_ACCOUNT_PROFILE);
            console.log("resp lead account profile ", resp)
            if (resp?.data?.status) {
                const final = resp?.data?.data;
                setAllItemList(Array.isArray(final) ? final : []);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    };


    // const fetchData = async () => {
    //     try {
    //         setLoading(true)
    //         const resp = await AXIOSCONFIGMETHOD("get", webServiceUrl.GET_LEAD_ACCOUNT_PROFILE);
    //         if (resp?.success) {
    //             const final = resp?.data;
    //             setAllItemList(final?.length > 0 && final);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching  data:", error);
    //     } finally {
    //         setTimeout(() => setLoading(false), 500);
    //     }
    // };
    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Lead Account Profile</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        All Lead Account Profile
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Performance Indicator list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Lead Account Profile List</h5>
                        </div>
                        <div className="card-body p-0">
                            {loading
                                ? <Loading />
                                : <Table dataSource={allItemList} rowKeyId={"lead_profile_id"} columns={columns} Selection={false} />
                            }
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
               <p className="mb-0">© {new Date().getFullYear()} Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default LeadAccProfile;
